/** The longest collection name the forms accept, counted after trimming, as the API stores it. */
export const COLLECTION_NAME_MAX_LENGTH = 200;
